import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTransferSearch } from './TransferSearchContext';
const LocationDropdown = ({ mode = 'from', otherFieldText = '', onChange, value }) => {
  const { setSearchData } = useTransferSearch();
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '24px',
      border: 'none',
      boxShadow: 'none',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      fontSize: '18px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#f7921e' : 'white',
      color: state.isSelected ? 'white' : 'black',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    }),
  };

  const formatOptionLabel = ({ label, icon }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      {icon && <img src={icon} alt="icon" width="20" height="20" />}
      <span>{label}</span>
    </div>
  );

  const fetchLocations = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return [];

    const searchLabel = otherFieldText?.label || '';

    try {
      const response = await fetch(
        'https://login.flymiles.com.au/api_sections/transafer/front_end/search_bar.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            search_results: inputValue,
            search_from_to: searchLabel,
          }),
        }
      );
     
      const data = await response.json();
      //console.log(data);
      return Array.isArray(data)
        ? data.map((item) => ({
            value: item.place_id || item.id,
            label: item.landmark,
            icon: item.icon,
            source: item.source
          }))
        : [];
    } catch (error) {
      console.error('Error fetching locations:', error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={fetchLocations}
      defaultOptions={false}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      placeholder=""
      noOptionsMessage={() => "Search by Airport Name / Cruise Terminal or Hotel Name"}
      value={value}
      onChange={(selectedOption) =>
        setSearchData((prev) => ({
          ...prev,
          [mode]: selectedOption, // dynamic "from" or "to"
        }))
      }
    />
  );
};

export default LocationDropdown;
